var render, staticRenderFns
import script from "./EventBus.vue?vue&type=script&lang=js"
export * from "./EventBus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitrix/ext_www/igr.ru/local/templates/main/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c3942b6')) {
      api.createRecord('6c3942b6', component.options)
    } else {
      api.reload('6c3942b6', component.options)
    }
    
  }
}
component.options.__file = "src/components/EventBus.vue"
export default component.exports